//quiz results.
import { useEffect, useState } from "react";
import { getTransactionData } from "../services/transactionService";

/**
 * Get result of transaction
 * @param transactionId
 * @returns {{status: string}}
 */
export default function useGetTransactionDetails(transactionId) {
    const [ transactionDetails, setTransactionDetails ] = useState({
        status: 'PENDING',
        data: {}
    });
    //get results.
    useEffect(() => {
        getTransaction(transactionId);
    }, [ transactionId ]);

    // get transaction details.
    function getTransaction(id) {
        if (id) {
            getTransactionData(id)
                .then((data) => {
                    setTransactionDetails({
                        status: 'SUCCESS',
                        data: data.data
                    });
                }).catch((Error) => {
                    setTransactionDetails({
                        data: {
                            status: 'ERROR',
                            data: {},
                            error: Error
                        }
                    });
                });
        }
    }

    return transactionDetails;
}
